module.exports = __webpack_public_path__ + "img/my-account-arrow-up.05bd65d5.svg";